<div class="server-switcher" (click)="setServer()"></div>

<ion-app>
  <ion-menu side="end" type="push" contentId="main" (ionDidOpen)="menuDidOpen()" (ionWillClose)="menuWillClose()">
    <ion-header>
      <ion-toolbar *ngIf="mainService.authentication.Active_bump_screen">
        <ion-thumbnail slot="start">
          <img src="assets/images/icons/pin.svg" />
        </ion-thumbnail>

        <ion-title>
          <p class="semibold toolbar-account-name">{{ mainService.authentication.Active_bump_screen.account }}</p>
          <p class="semibold toolbar-account-title">{{ mainService.authentication.Active_bump_screen.title }}</p>
          <p class="toolbar-account-email">{{ mainService.authentication.Email }}</p>
        </ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list lines="full">
        <!-- Admin Links -->
        <ion-item-group>
          <ion-list-header>
            <ion-label>Operations</ion-label>
          </ion-list-header>

          <ion-item
            *ngFor="let link of appConfig.admin_links"
            class="sidemenu-item admin-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('AdminLink', link.view_url)"
          >
            <ion-icon *ngIf="link.icon" src="assets/images/icons/{{ link.icon }}.svg"></ion-icon>
            {{ link.label }}
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Printer setup -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.navigateTo(['/printer-setup'])"
          >
            <ion-icon src="assets/images/icons/printer.svg"></ion-icon>
            Printer Setup
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <ion-item
            *featureFlag="'docketLayout'"
            class="sidemenu-item account-link docket-layout-link ion-activatable ripple-parent"
            (click)="mainService.navigateTo(['/docket'])"
          >
            <ion-icon src="assets/images/icons/docket.svg"></ion-icon>
            Docket Layout
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>
        </ion-item-group>

        <ion-item-group>
          <ion-list-header>
            <ion-label>Concierge</ion-label>
          </ion-list-header>

          <!-- VIP setup -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent concierge-menu-icon"
            (click)="mainService.sideMenuClicked('VipSettings')"
          >
            <ion-icon src="assets/images/icons/vip.svg"></ion-icon>
            VIP Settings
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Wait Time -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent concierge-menu-icon"
            (click)="mainService.sideMenuClicked('AdminLink', 'om/wait-time')"
          >
            <ion-icon src="assets/images/icons/wait-time.svg"></ion-icon>
            Wait Time
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Feedback -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent concierge-menu-icon"
            (click)="mainService.sideMenuClicked('AdminLink', 'consumer-feedback')"
          >
            <ion-icon src="assets/images/icons/feedback.svg"></ion-icon>
            Feedback
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>
        </ion-item-group>

        <!-- Order Links -->
        <ion-item-group>
          <ion-list-header>
            <ion-label>Orders</ion-label>
          </ion-list-header>

          <!-- Order summary -->
          <ion-item
            class="sidemenu-item ion-activatable ripple-parent"
            (click)="mainService.navigateTo(['/item-summary'])"
          >
            <ion-icon src="assets/images/icons/item_summary.svg"></ion-icon>
            Order Summary
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>
        </ion-item-group>

        <!-- Account Links -->
        <ion-item-group>
          <ion-list-header>
            <ion-label>Setup</ion-label>
          </ion-list-header>

          <!-- Walkthrough -->
          <!-- <ion-item class="sidemenu-item ion-activatable ripple-parent" *ngIf="mainService.walkthrough.getMaxSeries() > 0" (click)="mainService.sideMenuClicked('Walkthrough')">
            <ion-icon src="assets/images/icons/intro.svg"></ion-icon>
            Intro
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item> -->

          <!-- APP Settings -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('ChangeSettings')"
          >
            <ion-icon src="assets/images/icons/settings.svg"></ion-icon>
            Settings
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Change Pin -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('AdminPin')"
          >
            <ion-icon src="assets/images/icons/security-code.svg"></ion-icon>
            <span *ngIf="!mainService.authentication.Admin_pin">Set Pin</span>
            <span *ngIf="mainService.authentication.Admin_pin">Change Pin</span>
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Change Password -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('ChangePassword')"
          >
            <ion-icon src="assets/images/icons/password.svg"></ion-icon>
            Change Password
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Change Screen -->
          <ion-item
            *ngIf="
              mainService.authentication.Active_bump_screen &&
              mainService.authentication.Bump_screens &&
              mainService.authentication.Bump_screens.length > 1
            "
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('SwitchScreen')"
          >
            <ion-icon src="assets/images/icons/switch.svg"></ion-icon>
            Change screen
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Support Widget -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('Support')"
          >
            <ion-icon src="assets/images/icons/support.svg"></ion-icon>
            Support
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>

          <!-- Sign out -->
          <ion-item
            class="sidemenu-item account-link ion-activatable ripple-parent"
            (click)="mainService.sideMenuClicked('Signout')"
          >
            <ion-icon src="assets/images/icons/logout.svg"></ion-icon>
            Sign out
            <ion-ripple-effect></ion-ripple-effect>
          </ion-item>
        </ion-item-group>
      </ion-list>
      <!-- BUILD DATE - VERSION -->
      <div class="buildDate" *ngIf="buildDate">
        {{ buildDate }}
      </div>

      <!-- BUILD DATE - VERSION -->
      <div class="buildDate resolution">
        {{ resolution }}
      </div>

      v
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>

  <hub-message-board></hub-message-board>
</ion-app>

<!-- COMMENT EXPERIMENTAL CODE -->
<!-- <hub-notif-display></hub-notif-display> -->

<!-- NETWORK DISCONNECTED -->
<div class="connection-error disconnected" [class.disconnected]="!diagnostics.isOnline" [class.mini]="connectionMinify">
  <ion-button class="close-btn" fill="clear" (click)="minify()">
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>
  <hub-no-network></hub-no-network>
  <div class="warning-holder">
    <h4>Uh-Oh! Slow or no internet connection</h4>
    <p>Maybe your internet’s hangry? Please check your connection while we try and reconnect.</p>
  </div>
</div>

<!-- SERVER ISSUE -->
<div
  class="connection-error disconnected"
  [class.disconnected]="!diagnostics.isOnline && diagnostics.serverIssue"
  [class.mini]="connectionMinify"
>
  <ion-button class="close-btn" fill="clear" (click)="minify()">
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>
  <hub-no-network></hub-no-network>
  <p>Uh-Oh! We're having problem connecting to our servers right now.</p>
</div>

<div class="dev-backlog-view" [class.minimized]="dev_box_minimized" *ngIf="mainService.core.DEV_MODE">
  <ion-toolbar class="header">
    <ion-buttons slot="end">
      <ion-button
        class="dev-backlog-header-btn"
        size="small"
        *ngIf="!dev_box_minimized"
        (click)="dev_box_minimized = true"
      >
        <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
      </ion-button>

      <ion-button
        class="dev-backlog-header-btn"
        size="small"
        *ngIf="dev_box_minimized"
        (click)="dev_box_minimized = false"
      >
        <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
      </ion-button>

      <ion-button class="dev-backlog-header-btn" size="small" (click)="mainService.core.DEV_MODE = false">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="dev-backlog-view-group">
    <p>QUEUE COUNT: {{ mainService.printer.printingJobsOnQueue }}</p>
  </div>
  <div class="dev-backlog-view-group">
    <p>BT PRINT BACKLOG: {{ mainService.printer.Backlog_bluetooth_print.length }}</p>
    <p *ngFor="let backlog of mainService.printer.Backlog_bluetooth_print">{{ backlog.printerAddress }}</p>
  </div>
  <div class="dev-backlog-view-group">
    <p>BT PING BACKLOG: {{ mainService.printer.Backlog_bluetooth_ping.length }}</p>
    <p *ngFor="let backlog of mainService.printer.Backlog_bluetooth_ping">{{ backlog.printerAddress }}</p>
  </div>
</div>
